import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

const JumbotronBanner = ({
  jumbotronType,
  backgroundBigText,
  jumbotronContainerClassName,
  jumbotronEntityInfoClassName,
  headingEl,
  breadcrumbs,
}) => {
  return (
    <div className={cs(jumbotronContainerClassName, jumbotronType)}>
      {backgroundBigText}
      <div className={cs('JumbotronBanner__wrapper', jumbotronType)}>
        {/* Header Entity Info Section */}
        <div className={`${jumbotronEntityInfoClassName}__container`}>
          <div className={jumbotronEntityInfoClassName}>
            {breadcrumbs}
            {headingEl}
          </div>
        </div>
      </div>
    </div>
  );
};

JumbotronBanner.propTypes = {
  jumbotronType: PropTypes.string.isRequired,
  backgroundBigText: PropTypes.object,
  jumbotronContainerClassName: PropTypes.string.isRequired,
  headingEl: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.object,
  jumbotronEntityInfoClassName: PropTypes.string.isRequired,
};

export default JumbotronBanner;
